import React from "react";
import PropTypes from "prop-types";
import axios from "axios";
import Switch from "react-switch";
import lodash from "lodash";
import ReactTooltip from "react-tooltip";

import MultiSelect from "../general/MultiSelect.js";

class NewUser extends React.Component {
  state = {
    firstName: "",
    lastName: "",
    email: "",
    phoneNumber: "",
    locations: [],
    positions: [],
    locationOptions: this.props.locations,
    positionOptions: this.props.positions,
    password: this.props.password,
    sendWelcomeEmail: true,
    sendWelcomeText: true,
    domainSuggestions: false,
    validEmail: false,
    errorMessage: null
  };

  componentDidMount() {
    let locationOptions = this.props.locations
    let positionOptions = this.props.positions
    locationOptions.unshift({id: 0, name: 'All Locations'})
    positionOptions.unshift({id: 0, name: 'All Positions'})
    this.setState({ locationOptions, positionOptions })
  }

  saveUser() {
    var that = this;

    axios
      .post("/check_email", {
        email: that.state.email
      })
      .then(function(response) {
        if (response.data.valid) {
          that.setState({
            errorMessage: null
          });

          var locations = [];
          var positions = [];

          _.forEach(that.state.locations, function(location) {
            locations.push({
              location_id: location.value,
              primary: true
            });
          });

          _.forEach(that.state.positions, function(position) {
            const default_position = that.props.positions.find(p => p.id == position.value);
            positions.push({
              position_id: position.value,
              hourly_rate: default_position && default_position.default_hourly_rate,
              code: default_position && default_position.default_code
            });
          });

          var user = {
            first_name: that.state.firstName,
            last_name: that.state.lastName,
            email: that.state.email,
            phone_number: that.state.phoneNumber,
            user_locations_attributes: locations,
            employee_positions_attributes: positions,
            password: that.state.password,
            password_confirmation: that.state.password,
            send_welcome_email: that.state.sendWelcomeEmail,
            send_welcome_text: that.state.sendWelcomeText
          };

          axios
            .post("/users.json", {
              user: user
            })
            .then(function(response) {
              toastr.success("Employee added");

              setTimeout(
                function() {
                  window.location.href = "/users/" + response.data.id;
                }.bind(this),
                300
              );
            })
            .catch(function(error) {
              if (error.response && error.response.data) {
                _.forEach(error.response.data, function(value, key) {
                  toastr.error(key + ' ' + value);
                })
              }
            });
        } else {
          toastr.error("An employee already exists with this email");

          that.setState({
            errorMessage: response.data.message
          });
        }
      });
  }

  userLimitReaching = () => {
    if (this.props.userTally.limit === 0) return false;

    return this.props.userTally.active >= this.props.userTally.limit;
  }

  userLimitReached = () => {
    if (this.props.userTally.limit === 0) return false;

    let userAllowedAfterOverLimit = 5;
    return this.props.userTally.active >= this.props.userTally.limit + userAllowedAfterOverLimit;
  }

  renderSaveButton() {
    var that = this;
    var valid = false;

    if (
      this.state.firstName &&
      this.state.lastName &&
      this.state.email &&
      this.state.password &&
      this.state.locations.length > 0 &&
      !this.userLimitReached()
    ) {
      valid = true;
    }

    if (valid) {
      return (
        <button
          type="button"
          className="btn btn-pink full-width"
          onClick={function() {
            that.saveUser();
          }}
        >
          SAVE
        </button>
      );
    } else {
      return (
        <button type="button" className="btn btn-pink full-width disabled">
          SAVE
        </button>
      );
    }
  }

  handleInputChange = event => {
    var value = event.target.value;
    var name = event.target.name;

    this.setState({
      [name]: value
    });
  };

  handleEmailChange = event => {
    var value = event.target.value;

    if (value && value.length > 0 && !value.includes("@")) {
      this.setState({
        domainSuggestions: true
      });
    } else {
      this.setState({
        domainSuggestions: false
      });
    }

    this.setState({
      email: value
    });
  };

  toggle(column) {
    var value = this.state[column];
    this.setState({ [column]: !value });
  }

  newState(object, stateKey) {
    this.setState({ [stateKey]: object });
  }

  autoCompleteEmail = domain => {
    var email = this.state.email + domain;

    this.setState({ email: email, domainSuggestions: false });
  };

  render() {
    var that = this;

    return (
      <div>
        <h1>New Employee</h1>
        <div className="u-form-width-fix well shadowDepth1">
          {this.userLimitReaching() ? (
            this.userLimitReached() ? (
              <div id="error_explanation">
                <p className="pink-text">
                  Maximum number of active users has been reached. Your plan includes up to {this.props.userTally.limit} employees, and up to five over that limit. Please review
                  &nbsp;<a className="styled-link" href="https://help.digiquatics.com/en/articles/6480357-account-overages-user-allowance#h_47bb3571ed">this article</a>&nbsp;
                  to consider your options.
                </p>
                <br />
              </div>
            ) : (
              <div id="error_explanation">
                <p className="pink-text">
                  Your plan includes up to {this.props.userTally.limit} employees, and up to five over that limit. Please review&nbsp;
                  <a href="https://help.digiquatics.com/en/articles/6480357-account-overages-user-allowance#h_47bb3571ed" target="_blank">this article</a>
                  &nbsp;to consider your options.
                </p>
                <br />
              </div>
            )
          ) : null}
          <p>* Indicates required field</p>
          <ReactTooltip />
          <label>First Name *</label>
          <input
            name="firstName"
            type="text"
            className="form-control"
            value={that.state.firstName}
            onChange={this.handleInputChange}
          />
          <label>Last Name *</label>
          <input
            name="lastName"
            type="text"
            className="form-control"
            value={that.state.lastName}
            onChange={this.handleInputChange}
          />

          <label>
            Phone Number
            <span
              style={{marginLeft: '10px'}}
              data-tip='Optionally add a phone number. Employees can update their phone number anytime.'
            >
              <i className="material-icons md-15">help_outline</i>
            </span>
          </label>
          <input
            name="phoneNumber"
            type="tel"
            className="form-control"
            value={that.state.phoneNumber}
            onChange={this.handleInputChange}
          />
          
          <label>
            Email *
            <span
              style={{marginLeft: '10px'}}
              data-tip='An email address is required for login. It should be a valid email address. Employees can update their email address anytime.'
            >
              <i className="material-icons md-15">help_outline</i>
            </span>
          </label>
          <input
            name="email"
            type="text"
            className="form-control"
            value={that.state.email}
            onChange={this.handleEmailChange}
          />

          {this.state.domainSuggestions && (
            <div>
              <span
                className="badge indigo mouse-over"
                onClick={() => that.autoCompleteEmail("@gmail.com")}
              >
                @gmail.com
              </span>
              &nbsp;
              <span
                className="badge indigo mouse-over"
                onClick={() => that.autoCompleteEmail("@yahoo.com")}
              >
                @yahoo.com
              </span>
              &nbsp;
              <span
                className="badge indigo mouse-over"
                onClick={() => that.autoCompleteEmail("@hotmail.com")}
              >
                @hotmail.com
              </span>
              &nbsp;
              <span
                className="badge indigo mouse-over"
                onClick={() => that.autoCompleteEmail("@outlook.com")}
              >
                @outlook.com
              </span>
              &nbsp;
              <span
                className="badge indigo mouse-over"
                onClick={() => that.autoCompleteEmail("@inbox.com")}
              >
                @inbox.com
              </span>
              &nbsp;
              <span
                className="badge indigo mouse-over"
                onClick={() => that.autoCompleteEmail("@icloud.com")}
              >
                @icloud.com
              </span>
              &nbsp;
              <span
                className="badge indigo mouse-over"
                onClick={() => that.autoCompleteEmail("@aol.com")}
              >
                @aol.com
              </span>
            </div>
          )}

          <hr />

          <label>Primary Locations *</label>
          <MultiSelect
            newOptsCallback={opt => this.newState(opt, "locations")}
            data={that.state.locationOptions}
            fieldPlaceholder="Select Primary Locations *"
            selectLabel="name"
            selectKey="id"
          />

          <br />

          <label>Positions</label>
          <MultiSelect
            newOptsCallback={opt => this.newState(opt, "positions")}
            data={that.state.positionOptions}
            fieldPlaceholder="Select Positions"
            selectLabel="name"
            selectKey="id"
          />

          <hr />

          <p>
            Send welcome email and/or text message to employee with their email
            and password alerting them how to login to DigiQuatics?
          </p>
          <label id="switch-send-email" htmlFor="add-user-email-switch">Send Email</label>
          <br />
          <Switch
            checked={that.state.sendWelcomeEmail}
            onChange={() => that.toggle("sendWelcomeEmail")}
            onColor="#DADCE1"
            onHandleColor="#3A4590"
            handleDiameter={25}
            aria-labelledby="switch-send-email"
            uncheckedIcon={false}
            checkedIcon={false}
            boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
            activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
            height={20}
            width={48}
            className="react-switch"
            id="add-user-email-switch"
          />
          <br />
          <label id="switch-send-text" htmlFor="add-user-material-switch">Send Text</label>
          <br />
          <Switch
            checked={that.state.sendWelcomeText}
            onChange={() => that.toggle("sendWelcomeText")}
            onColor="#DADCE1"
            onHandleColor="#3A4590"
            handleDiameter={25}
            aria-labelledby="switch-send-text"
            uncheckedIcon={false}
            checkedIcon={false}
            boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
            activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
            height={20}
            width={48}
            className="react-switch"
            id="add-user-material-switch"
          />
          <hr />

          <p>
            Manually set password for employee? Note: This will override the
            randomly generated unique password below, to be sent the
            employee.
          </p>

          <label>
            Password *
            <span
              style={{marginLeft: '10px'}}
              data-tip='Password must be 6 characters or greater.'
            >
              <i className="material-icons md-15">help_outline</i>
            </span>
          </label>
          <input
            name="password"
            type="text"
            className="form-control"
            value={that.state.password}
            onChange={this.handleInputChange}
          />

          <hr />

          {this.state.errorMessage && (
            <div id="error_explanation">
              <p className="pink-text">{this.state.errorMessage}</p>
              <br />
            </div>
          )}

          {this.renderSaveButton()}
        </div>
      </div>
    );
  }
}

NewUser.propTypes = {
  locations: PropTypes.array,
  positions: PropTypes.array,
  password: PropTypes.string,
  userTally: PropTypes.object
};

export default NewUser;
